import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SortType} from "../../../commons/types/sort.type";
import {SplitService} from "../../../commons/services/split-service.service";

export class PlanningJobsTableCtrl implements IController {
  jobs: any;
  depots: any;
  selectedIds: any;
  isDraft: any;
  query: any;
  sourceType: any;
  skills: any;
  tags: any;
  resourceIds: any;
  areaIds: any;
  inRoute: any;
  isPacked: any;
  sortSlaType: any;
  onSortSlaTypeChange: Function;
  onSelect: Function;
  onView: Function;
  onRemove: Function;
  onAddToDraft: Function;
  onRemoveFromDraft: Function;
  onJobChange: Function;

  private selectedKeys: object;
  private asceDescIconsMap: any;
  private depotsMap: any;
  private filteredJobs: any;

  /* @ngInject */
  constructor(private commonsConstants, private splitService: SplitService) {
    this.selectedKeys = {};
    this.asceDescIconsMap = commonsConstants.sortIconsMap;
  }

  $onInit() {
    if (this.jobs) {
      this.filteredJobs = _.filter(this.jobs, (j) => {
        return this._filterJobByFilters(j)
      })
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.jobs && !changes.jobs.isFirstChange()) {
      if (this.jobs) {
        this.filteredJobs = _.filter(this.jobs, (j) => {
          return this._filterJobByFilters(j)
        })
      }
    }
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }
    if (changes.depots) {
      this.depotsMap = _.keyBy(this.depots, (d) => {
        return d.syncId;
      });
    }

    if (changes.skills && !changes.skills.isFirstChange() ||
      changes.query && !changes.query.isFirstChange() ||
      changes.tags && !changes.tags.isFirstChange() ||
      changes.areaIds && !changes.areaIds.isFirstChange() ||
      changes.resourceIds && !changes.resourceIds.isFirstChange() ||
      changes.inRoute && !changes.inRoute.isFirstChange() ||
      changes.isPacked && !changes.isPacked.isFirstChange()) {

      this.filteredJobs = _.filter(this.jobs, (j) => {
        return this._filterJobByFilters(j)
      })
    }
  }

  onToggleJob(id, isSelected: boolean) {
    this.selectedKeys[id] = isSelected;
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.onSelect({ids: _.compact(selectedIds)});
  }

  onToggleAllJobs() {
    // const selectedIds: any[] = !_.isEqual(this.selectedIds.length, this.filteredJobs.length) ?
    //   _.map(this.filteredJobs, function (job) {
    //     return job.id;
    //   }) : [];
    //


    const selectedIds: any[] = !this.selectedIds.length ?
      _.chain(this.filteredJobs)
        .filter((j) => {
          return !j.locked
        })
        .map((filteredJob) => {
          return filteredJob.id;
        })
        .value() : [];

    this.onSelect({ids: selectedIds});
  }

  onPriorityChange(job, priority) {
    job.priority = priority;
    this.onJobChange({job: job})
  }

  private _filterJobByFilters(job) {
    const shouldReturnByQuery: boolean = this.filterByQuery(job);
    const shouldReturnBySkill: boolean = this._filterBySkills(job);
    const shouldReturnByTags: boolean = this.filterByTags(job);
    const shouldReturnByAreaIds: boolean = this.filterByAreaIds(job);
    const shouldReturnByResourceIds: boolean = this.filterByResourceIds(job);
    const shouldReturnByInRoute: boolean = this.filterByInRoute(job);
    const shouldReturnByIsPacked: boolean = this.filterByIsPacked(job)
    return shouldReturnByQuery &&
      shouldReturnBySkill &&
      shouldReturnByTags &&
      shouldReturnByResourceIds &&
      shouldReturnByAreaIds &&
      shouldReturnByInRoute &&
      shouldReturnByIsPacked;
  }

  onToggleSlaSortType() {
    const sortType = this.sortSlaType ? (this.sortSlaType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this.onSortSlaTypeChange({sortType: sortType});
  }

  private filterByQuery(job) {


    return !this.query ? true : _.includes(JSON.stringify(job), this.query);
  }

  private _filterBySkills(job) {
    return !_.get(this.skills, 'length') || _.filter(job.skills, (skill) => {
      return _.includes(this.skills, skill);
    }).length > 0;
  }

  private filterByTags(job) {
    const noTags = !!_.find(this.tags, (tag) => {
      return tag === 'noTag';
    })

    if (!_.get(job, 'tags.length')) {
      return _.get(this.tags, 'length', false) ? noTags : true;
    } else {
      return !_.get(this.tags, 'length') || _.filter(job.tags, (tag) => {
        return _.includes(this.tags, tag);
      }).length > 0;
    }

  }


  private filterByAreaIds(job) {
    return !_.get(this.areaIds, 'length') || _.filter(job.areaIds, (aid) => {
      return _.includes(this.areaIds, aid);
    }).length > 0;
  }

  private filterByResourceIds(job) {
    return !_.get(this.resourceIds, 'length') || _.includes(this.resourceIds, job.resourceId);
  }

  private filterByInRoute(job) {
    return _.isUndefined(this.inRoute) || _.isEqual(job.routed, this.inRoute);
  }

  private filterByIsPacked(job) {
    return _.isUndefined(this.isPacked) || _.isEqual(job.packed, this.isPacked);
  }

}

angular
  .module('bringoz.admin.planning')
  .component(
    'planningJobsTable', {
      bindings: {
        jobs: '<',
        depots: '<',
        selectedIds: '<',
        isDraft: '<?',
        query: '<?',
        sourceType: '<?',
        skills: '<?',
        tags: '<?',
        resourceIds: '<?',
        areaIds: '<?',
        inRoute: '<?',
        isPacked: '<?',
        sortSlaType: '<?',
        onSortSlaTypeChange: '&',
        onSelect: '&',
        onView: '&',
        onRemove: '&',
        onAddToDraft: '&',
        onRemoveFromDraft: '&',
        onJobChange: '&'
      },
      template: require('./planning-jobs-table.html').default,
      controller: PlanningJobsTableCtrl
    }
  );
